import React, {Component} from 'react';
import classNames from 'classnames';
import AppConfig from '../../../../../../appConfig/AppConfig';
import placeholderImage from './assets/placeholder.svg';
const config = AppConfig();

export class NearbyFuneralHome extends Component {
  static propTypes = {
    funeralHome: React.PropTypes.object,
  };

  positiveRating(rating, starRating) {
    return rating <= starRating ? 'rating-positive' : null;
  }

  buildFullRelativePath() {
    const betaPath = config.baseUrl.beta;

    return betaPath + this.props.funeralHome.url;
  }

  renderRating(starRating) {
    if (starRating) {
      const ratingScale = [1, 2, 3, 4, 5];

      return (
        <div className="rating-scale">
          {ratingScale.map((rating, i) => (
            <div
              key={i}
              className={classNames(
                'rating',
                this.positiveRating(rating, starRating)
              )}
            />
          ))}
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      isPremium,
      name,
      city,
      state,
      imageUrl,
      starRating,
    } = this.props.funeralHome;

    const partner = isPremium ? <div className="partner">Partner</div> : null;
    const image = imageUrl ? imageUrl : placeholderImage;

    return (
      <a className="funeral-homes-nearby" href={this.buildFullRelativePath()}>
        <div
          className="funeral-homes-nearby__image"
          style={{backgroundImage: `url(${image})`}}
        />
        {partner}
        <div className="funeral-homes-nearby__text-container">
          {this.renderRating(starRating)}
          <header className="funeral-homes-nearby__name">{name}</header>
          <div className="funeral-homes-nearby__location">
            {city}, {state}
          </div>
        </div>
      </a>
    );
  }
}

export default NearbyFuneralHome;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/NearbyFuneralHomes/NearbyFuneralHome.js